import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  caption: {
    position: 'absolute',
    right: 0,
    top: 6,
  },
  control: {
    position: 'relative',
    width: '100%',
  },
}));
